import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Translate, Localize } from 'react-redux-i18n';
import Dropzone from 'react-dropzone';
import { Link } from 'react-router';
import {
  Grid, Row, Col, Panel, ButtonToolbar, Button, Table, Breadcrumb, Input,
  Dropdown, MenuItem
} from 'react-bootstrap';
import _ from 'lodash'
import { SkyLightStateless } from 'react-skylight';

import { UI_HEIGHT } from '../Common/constants';
import checkPermission from '../Common/permissions';
import FilterToolbar from "../Common/FilterToolbar.jsx";
import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import { ROOT_URL, companyCodeTitle, isGGI, isVAK, isGFD, isAP } from '../../actions/root_url';
import PriceTableModal from './priceTableModal';
import PriceTableFormModal from './priceTableFormModal';

class Vendors extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.customersPage,
      rows: [],
      selectedRows: null,
      filters: {},
      sortColumn: null,
      sortDirection: null,
      files: null,
      priceTableModalVisibility: false,
      priceTableFormModalVisibility: false,
      priceTableSelectedRows: [],
      searchFilter: {
        vendor_num: '',
        name: '',
        description: '',
        is_active: '',
        City: '',
        State: '',
      },
      activeDisplay: <Translate value="all" />,
    };

    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    window.addEventListener('resize', this.handleResize);
    this.props.fetchVendors();
  }

  componentDidUpdate() {
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  // Once vendors ready, reset state.

  componentWillReceiveProps(nextProps) {
    if (nextProps.vendors && nextProps.vendors != this.props.vendors) {
      this.setState({ rows: nextProps.vendors });
    }
    if (this.props.selectedCompany !== nextProps.selectedCompany) {
      this.props.fetchVendors();
    }
  }

  handleResize(e) {
    this.setState({tableHeight: window.innerHeight - UI_HEIGHT.customersPage});
  }

  // Set vendor being selected to be currentVendor and navigate user to the edit page
  onDrop(files) {
    if (files) {
      alert('Upload takes time, please stay on the current page');
    }
    this.props.attachDocument(files);
    this.setState({ files });
  }

  setCurrentVendor(e) {
    e.preventDefault();
    const currentVendor = this.state.selectedRows[0];
    this.props.resetCurrentVendor();
    this.props.selectVendor(currentVendor);
    this.context.router.push('/vendors/'+currentVendor.Vendor_id);
  }

  clickNew(e) {
    e.preventDefault();
    this.props.resetCurrentVendor();
    this.context.router.push('/vendors/new');
  }

  // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

  renderTable() {
    if (this.props.isLoading && !this.props.error) {
      return (
        <Spinner/>
      );
    } else if (this.props.error) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">
            {JSON.stringify(this.props.error)}
          </div>
        </ContentWrapper>
      );
    } else {
      // Parameters of the react-data-grid

      const getRows = () => {
        return Data.Selectors.getRows(this.state);
      }

      const getSize = () => {
        return getRows().length;
      }

      const rowGetter = rowIdx => {
        var rows = getRows();
        return rows[rowIdx];
      }

          // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
        var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
        this.setState(state);
      }

      const handleFilterChange = filter => {
        let newFilters = Object.assign({}, this.state.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        this.setState({ filters: newFilters });
      }

      //Custom Formatter component
      const IsActiveFormatter = React.createClass({
        render() {
          if (this.props.value) return <span className="label label-success"><Translate value="active" /></span>;
          else return <span className="label label-danger"><Translate value="inactive" /></span>;
        }
      });

      // Handle the row select function

      const onRowSelect = rows => {
        this.setState({ selectedRows: rows });
      }

      // Column difinition

      const columns = [
        {
          key: 'VendorNum',
          name: <Translate value="vendor_no" />,
          width: 125,
          resizable: true,
          sortable: true,
          filterable: true
        }, {
          key: 'Name',
          name: <Translate value="name" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 250,
        }, {
          key: 'Description',
          name: <Translate value="description" />,
          width: 200,
          resizable: true,
          sortable: true,
          filterable: true
        },
        ...isVAK ? [
          {
            key: 'city',
            name: <Translate value="city" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 100,
          },
          {
            key: 'state',
            name: <Translate value="state" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 60,
          },
        ]:[],
        ...isGFD && [{
          key: 'VendorScore', // VendorScore, PaymentTerm_id__Name
          name: <Translate value="score" />,
          width: 90,
          resizable: true,
          sortable: true,
          filterable: true,
          formatter: ({ value }) => {
            let grade = 'none';
            let score = Number(value);
            if (score < 70) {
              grade = 'Grade D&F';
            } else if (score >= 70 && score <80) {
              grade = 'Grade C';
            } else if (score >= 80 && score <90) {
              grade = 'Grade B';
            } else if (score >= 90) {
              grade = 'Grade A';
            } 
            return(
              <div>{grade}</div>
            )
          },
        }],
        {
          key: 'PaymentTerm_id__Name',
          name: <Translate value="payment_term" />,
          width: 120,
          resizable: true,
          sortable: true,
          filterable: true
        },
        {
          key: 'CreditStatus',
          name: <Translate value="credit_status" />,
          width: 120,
          resizable: true,
          sortable: true,
          filterable: true
        }, 
        ...isAP ? [{
          key: 'Level',
          name: <Translate value="Level" />,
          width: 60,
          resizable: true,
          sortable: true,
          filterable: true
        },]:[],
        {
          key: 'IsActive',
          name: <Translate value="active" />,
          width: 65,
          resizable: true,
          sortable: true,
          filterable: true,
          formatter: IsActiveFormatter
        }
      ]

      if (isGGI) {
        const refCol = {
          key: 'RefNum',
          name: <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 120,
        }
        const nameIndex = _.findIndex(columns, { key: 'Name' });
        columns.splice(nameIndex, 0, refCol)
      }

      return (
        //React Table Vendors List
        <Row>
          <Col sm={ 12 }>
            <div id="Vendors-dataGrid1" style={{ marginTop: isVAK ? '85px' : '0' }}>
              <ReactDataGrid
                rowKey='Vendor_id'
                enableCellSelect={true}
                onGridSort={handleGridSort}
                toolbar={!isVAK ? <FilterToolbar enableFilter/> : null}
                onAddFilter={handleFilterChange}
                columns={columns}
                rowHeight={25}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize() }
                minHeight={this.state.tableHeight}
                enableRowSelect='single'
                onRowUpdated={this.handleRowUpdated}
                onRowSelect={onRowSelect}
              />
            </div>
          </Col>
        </Row>
      )
    }
  }

  handleOpenPriceTable = () => {
    const currentVendor = this.state.selectedRows[0];
    this.props.resetCurrentVendor();
    this.props.selectVendor(currentVendor);
    this.setState({
      priceTableModalVisibility: true,
    })
  }
  handleClosePriceTable = () => {
    this.setState({
      priceTableModalVisibility: false,
    });
  }
  handleOpenPriceTableForm = (selectedRows = []) => {
    this.setState({
      priceTableModalVisibility: false,
      priceTableFormModalVisibility: true,
      priceTableSelectedRows: selectedRows,
    });
  }
  handleClosePriceTableForm = openPriceTable => {
    this.setState({
      priceTableFormModalVisibility: false,
      priceTableModalVisibility: !!openPriceTable
    })
  }
  renderSearchFilter() {
    const isActiveSelection = [
      {
        label: <Translate value="all" />,
        value: '',
        name: 'is_active',
      },
      {
        label: <Translate value="active" />,
        value: '1',
        name: 'is_active',
      },
      {
        label: <Translate value="inactive" />,
        value: '0',
        name: 'is_active',
      },
    ]
    const handleOnSubmit = (event) => {
      event.preventDefault();
    }
    const handleFilterChangeDropdown = (el) => {
      let keys = Object.keys(this.state.searchFilter);
      for (let i = 0; i < keys.length; i++) {
        if (el.name === keys[i]) {
          this.state.searchFilter[keys[i]] = el.value;
          if (el.name === 'is_active') {
            this.setState({ activeDisplay: el.label });
          }
        }
      }
      this.props.fetchVendors(this.state.searchFilter);
    }
    const handleFilterChange = (event) => {
      let keys = Object.keys(this.state.searchFilter);
      for (let i = 0; i < keys.length; i++) {
        if (event.target.name === keys[i]) {
          this.state.searchFilter[keys[i]] = event.target.value;
        }
      }
      this.props.fetchVendors(this.state.searchFilter);
    }
    return (
      <div style={{ width: '1400px' }}>
        <Row>
          <Col md={12}>
            <div className="form-group" style={{ marginBottom: '0px', marginTop: '30px', position: 'absolute', zIndex: 2 }} id="search-product-by">
              <form autoComplete='off' onSubmit={handleOnSubmit}>
                <Row>
                  <Col>
                    <label className="col-sm-3" style={{ width: '120px' }}><Translate value="vendor_no" /></label>
                    <label className="col-sm-3" style={{ width: '120px' }}><Translate value="name" /></label>
                    <label className="col-sm-3" style={{ width: '120px' }}><Translate value="description" /></label>
                    <label className="col-sm-3" style={{ width: '120px' }}><Translate value="city" /></label>
                    <label className="col-sm-3" style={{ width: '120px' }}><Translate value="state" /></label>
                    <label className="col-sm-3" style={{ width: '115px' }}><Translate value="active" /></label>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-sm-3" style={{ width: '120px' }} >
                    <Input name="vendor_num" type="text" onChange={handleFilterChange} />
                  </Col>
                  <Col className="col-sm-3" style={{ width: '120px' }} >
                    <Input name="name" type="text" onChange={handleFilterChange} />
                  </Col>
                  <Col className="col-sm-3" style={{ width: '120px' }} >
                    <Input name="description" type="text" onChange={handleFilterChange} />
                  </Col>
                  <Col className="col-sm-3" style={{ width: '120px' }} >
                    <Input name="City" type="text" onChange={handleFilterChange} />
                  </Col>
                  <Col className="col-sm-3" style={{ width: '120px' }} >
                    <Input name="State" type="text" onChange={handleFilterChange} />
                  </Col>
                  <Col className="col-sm-3" style={{ width: '115px' }} >
                    <Dropdown>
                      <Dropdown.Toggle style={{ width: '100px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                        {this.state.activeDisplay}
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="super-colors">
                        {isActiveSelection.map(el => {
                          return (
                            <MenuItem onClick={() => handleFilterChangeDropdown(el)}>{el.label}</MenuItem>
                          )
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                </Row>
              </form>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
  render() {
    const createDialogStylePT = {
      height: '730px',
      marginTop: '-20%',
      width: '850px',
      marginLeft: '-15%',
      left: '45%',
    };
    const { selectedCompany, isAttachingDocument } = this.props;

    let height = (this.state.tableHeight + 70).toString();
    let tableCollapseFix = {height: height}
    const excelUrl = `${ROOT_URL}v1/vendor/export/?Bearer=${localStorage.getItem('token')}&Company_id=${selectedCompany.value}`;
    const excelUrlBarcode = `${ROOT_URL}v1/vendor/export-product-barcode/${this.state.selectedRows && this.state.selectedRows[0].Vendor_id}/?Bearer=${localStorage.getItem('token')}&Company_id=${selectedCompany.value}`;
    const hasPriceTablePermission = checkPermission('vendor_price_table') || checkPermission('vendor_price_table_manage');
    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>
        {/* Nav Trail */}
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="general_management"  />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="vendor" />
          </Breadcrumb.Item>
        </Breadcrumb> {/* End Nav Trail */}

        <Grid fluid="true" id="vendors-page">
          <h1><Translate value="manage_vendors" /></h1>
          <Row>
            <Col md={ 12 }>
              <Panel className="position-relative" style={tableCollapseFix}>
                <ButtonToolbar className="table-buttons" style={{ display: 'flex' }}>
                  <Button
                    bsStyle="success"
                    type="submit"
                    onClick={(event) => { this.clickNew(event) } }
                    disabled={!checkPermission("add_vendor")}
                  >
                    <em className="fa fa-plus" /><Translate value="create" />
                  </Button>
                  <Button
                    bsStyle="warning"
                    onClick={(event) => { this.setCurrentVendor(event) } }
                    disabled={!this.state.selectedRows || this.state.selectedRows.length != 1 || !checkPermission("change_vendor")}
                  >
                    <em className="fa fa-pencil"/><Translate value="edit" />
                  </Button>
                  <Button
                    bsStyle="success"
                    type="button"
                    href={excelUrl}
                    disabled={(isGGI && !checkPermission('excel_vendor'))}
                  >
                    <em className="fa fa-download"/><Translate value="excel" />
                  </Button>
                  <Button
                    bsStyle="success"
                    type="button"
                  //   onClick={(event) => { console.log('this.state', this.state) } }
                    disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}
                    href={excelUrlBarcode}
                  >
                    <em className="fa fa-download"/><Translate value="barcode_export" />
                  </Button>
                  <Dropzone onDrop={this.onDrop.bind(this)} style={{ 'padding-left': '5px' }} className="upload-button">
                    <Button bsStyle="primary" disabled={isAttachingDocument} >
                      <em className={`fa ${this.props.isAttachingDocument ? 'fa-spinner fa-spin' : 'fa-file-text'}`} />
                      <Translate value="upload_import" />
                    </Button>
                  </Dropzone>
                  <Button
                    bsStyle="primary"
                    type="button"
                  //   onClick={(event) => { console.log('this.state', this.state) } }
                    // disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}
                    href={`https://scmteambucket.s3.us-west-1.amazonaws.com/VendorsTemplate.csv`}
                  >
                    <em className="fa fa-file-text" />
                    <Translate value="vendor_template_download" />
                  </Button>
                  {isVAK && <Button
                    bsStyle="success"
                    type="button"
                    onClick={this.handleOpenPriceTable}
                    disabled={!this.state.selectedRows || this.state.selectedRows.length != 1 || !hasPriceTablePermission}
                  >
                    <Translate value="price_table" />
                  </Button>}
                </ButtonToolbar>
                {/* Vendor Table */}
                {isVAK && this.renderSearchFilter()}
                {this.renderTable() }
              </Panel>
            </Col>
          </Row>
        </Grid>
        <SkyLightStateless dialogStyles={createDialogStylePT} isVisible={this.state.priceTableModalVisibility} onCloseClicked={this.handleClosePriceTable} title={<Translate value="price_table" />}>
          <PriceTableModal onOpenForm={this.handleOpenPriceTableForm}/>
        </SkyLightStateless>
        <SkyLightStateless dialogStyles={createDialogStylePT} isVisible={this.state.priceTableFormModalVisibility} onCloseClicked={this.handleClosePriceTableForm} title={<Translate value="price_table_form" />}>
          <PriceTableFormModal editRow={this.state.priceTableSelectedRows} onConfirm={this.handleClosePriceTableForm} onCancel={this.handleClosePriceTableForm}/>
        </SkyLightStateless>
      </ContentWrapper>
      //---------------
      // End HTML
      //---------------
    );
  }
}

export default Vendors;



// WEBPACK FOOTER //
// ./master/jsx/components/Vendors/vendors.jsx